import { Component, input, output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import type { ListViewColumn } from '../grouped-list/grouped-list.component';
import { TPipe } from '../../pipes/t.pipe';

@Component({
  selector: 'app-list-view-column-bar',
  standalone: true,
  imports: [LucideAngularModule, TPipe],
  templateUrl: './list-view-column-bar.component.html',
})
export class ListViewColumnBarComponent {
  /** Colunas visíveis (ordenadas) */
  columns = input.required<ListViewColumn[]>();

  openFieldsModal = output<void>();
  addColumn = output<void>();
  hideColumn = output<string>();
}
